import * as React from 'react';

import { DataTableView, Column, ToolbarVisibility } from "src/core/ui/data-table.view";
import { MarketEditorController } from 'src/app/general/market/parts/market-editor.controller';

interface ContractsMarketViewProps extends ComponentViewProps<DataSet<ContractMarketItem>> {
	mode: ControlMode;
	createNew: () => any;
	afterDeleteItem: (items: any[]) => void;
}

export class ContractsMarketView extends React.Component<ContractsMarketViewProps, any> {
	public columns: Column[] = [
		{
			key: 'marketName',
			dataIndex: 'marketName',
			title: 'Market',
			editable: (text: string, record: ContractMarketItem, index: number, isSelected: boolean) => {
				if (isSelected) {
					return (
						<MarketEditorController
							label={null}
							mode={"edit"}
							setBusy={this.props.setBusy}
							value={record.marketId}
							onChanged={this.marketChange(record)}
						/>
					)
				}
				return record.marketName || "";
			}
		}
	];

	public constructor(props) {
		super(props);
	}

	public render() {
		const { createNew, mode, model, afterDeleteItem, setBusy } = this.props;
		if (model == null) {
			return null;
		}

		return (
			<DataTableView
				mode={mode}
				setBusy={setBusy}
				columns={this.columns}
				model={model}
				createNewItem={createNew}
				hideToolbar={ToolbarVisibility.hideSearch}
				afterDeleteItem={afterDeleteItem}
			/>
		);
	}

	private marketChange = (record: ContractMarketItem) => (item: MarketSummary) => {
		record.marketId = item.id;
		record.marketName = item.name;
		record.marketCurrencyId = item.currencyId;
		record.marketDefaultMargin = item.defaultMargin;
		record.marketMarginPolicy = item.marginPolicy;
		record.marketMarketPriceType = item.marketPriceType;
	}
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/contract-market.view.tsx